var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('v-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submitFilters.apply(null, arguments);
      }
    }
  }, [_c('v-row', {
    staticClass: "statistic-header"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "2"
    }
  }, [_c('date-time-picker', {
    attrs: {
      "textFieldProps": Object.assign({}, _vm.textFieldProps, {
        required: true,
        errorMessages: _vm.fromDateErrorMessages
      }),
      "datePickerProps": {
        max: _vm.datePickerMaxDate
      },
      "label": 'From Date (GMT+' + _vm.getGmtDiff + ')'
    },
    model: {
      value: _vm.fromDate,
      callback: function ($$v) {
        _vm.fromDate = $$v;
      },
      expression: "fromDate"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "2"
    }
  }, [_c('date-time-picker', {
    attrs: {
      "textFieldProps": Object.assign({}, _vm.textFieldProps, {
        required: true,
        errorMessages: _vm.untilDateErrorMessages
      }),
      "label": 'Until Date (GMT+' + _vm.getGmtDiff + ')',
      "datePickerProps": {
        max: _vm.untilDatePickerMaxDate
      }
    },
    model: {
      value: _vm.untilDate,
      callback: function ($$v) {
        _vm.untilDate = $$v;
      },
      expression: "untilDate"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "2"
    }
  }, [_c('v-select', {
    staticClass: "font-weight-bold tenant-select",
    attrs: {
      "outlined": "",
      "items": _vm.tenants,
      "item-text": "name",
      "item-value": "id",
      "menu-props": {
        maxHeight: '400'
      },
      "label": "Select tenants",
      "multiple": "",
      "single-line": "",
      "hide-details": "",
      "chips": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (_ref) {
        var item = _ref.item,
          attrs = _ref.attrs,
          parent = _ref.parent;
        return [_c('v-list-item-action', [_c('v-simple-checkbox', {
          attrs: {
            "color": "primary",
            "value": attrs.inputValue,
            "ripple": false
          },
          on: {
            "input": function ($event) {
              return parent.$emit('select', item);
            }
          }
        })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.name))])], 1), _vm.tenants.length > 1 && _vm.selectedValues && _vm.selectedValues.length > 0 ? _c('v-list-item-action', {
          staticClass: "tenant-only-action"
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "text": "",
            "color": "primary"
          },
          on: {
            "mousedown": function ($event) {
              $event.stopPropagation();
              $event.preventDefault();
            },
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.selectOnlyTenant(item.id);
            }
          }
        }, [_vm._v(" Only ")])], 1) : _vm._e()];
      }
    }, {
      key: "selection",
      fn: function (_ref2) {
        var item = _ref2.item,
          index = _ref2.index;
        return [index < 1 ? _c('v-chip', {
          attrs: {
            "small": ""
          }
        }, [_c('span', {
          staticClass: "text-truncate"
        }, [_vm._v(_vm._s(item.name))])]) : _vm._e(), index === 1 ? _c('span', {
          staticClass: "grey--text text-caption"
        }, [_vm._v(" (+" + _vm._s(_vm.selectedValues.length - 1) + ") ")]) : _vm._e()];
      }
    }]),
    model: {
      value: _vm.selectedValues,
      callback: function ($$v) {
        _vm.selectedValues = $$v;
      },
      expression: "selectedValues"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.eventStatus,
      "item-text": "label",
      "item-value": "value",
      "placeholder": "Filter by Claim Events",
      "outlined": "",
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: _vm.event.status,
      callback: function ($$v) {
        _vm.$set(_vm.event, "status", $$v);
      },
      expression: "event.status"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('v-btn', {
    staticClass: "wrapping-btn",
    staticStyle: {
      "height": "56px",
      "width": "100%"
    },
    on: {
      "click": function ($event) {
        _vm.uploadDialog = true;
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("mdi-file-upload-outline")]), _vm._v(" Upload External Reports to Match (Optional) ")], 1), _c('v-dialog', {
    attrs: {
      "max-width": "600px"
    },
    model: {
      value: _vm.uploadDialog,
      callback: function ($$v) {
        _vm.uploadDialog = $$v;
      },
      expression: "uploadDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Upload external reports")]), _c('v-card-text', [_c('div', {
    staticClass: "mb-4"
  }, [_c('file-uploader-mini', {
    ref: "fileUploaderTora",
    attrs: {
      "multiple": false,
      "text": 'Upload Tora report (Optional)'
    }
  })], 1), _c('div', {
    staticClass: "mb-4"
  }, [_c('file-uploader-mini', {
    ref: "fileUploaderSilverRail",
    attrs: {
      "multiple": false,
      "text": 'Upload SilverRail report (Optional)'
    }
  })], 1), _c('div', [_c('file-uploader-mini', {
    ref: "fileUploaderSwish",
    attrs: {
      "multiple": false,
      "text": 'Upload Swish report (Optional)'
    }
  })], 1), _c('div', {
    staticClass: "mt-6"
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Include external Kustom payment data (optional)",
      "hide-details": ""
    },
    model: {
      value: _vm.matchWithKustom,
      callback: function ($$v) {
        _vm.matchWithKustom = $$v;
      },
      expression: "matchWithKustom"
    }
  }), _c('div', {
    staticClass: "text-caption grey--text mt-1 ml-8"
  }, [_vm._v(" Kustom data is fetched automatically, so no report upload is needed. ")])], 1)]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.uploadDialog = false;
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1), _c('v-col', {
    staticClass: "d-flex align-center flex-wrap",
    staticStyle: {
      "gap": "8px"
    },
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "8"
    }
  }, [_c('span', {
    staticClass: "text-caption grey--text text--darken-1 mr-1"
  }, [_vm._v("Quick ranges")]), _vm._l(_vm.datePresets, function (preset) {
    return _c('v-chip', {
      key: preset.key,
      attrs: {
        "color": preset.key === _vm.activeDatePreset ? 'primary' : undefined,
        "outlined": preset.key !== _vm.activeDatePreset
      },
      on: {
        "click": function ($event) {
          return _vm.applyDatePreset(preset);
        }
      }
    }, [_vm._v(" " + _vm._s(preset.label) + " ")]);
  })], 2), _c('v-col', {
    staticClass: "d-flex",
    staticStyle: {
      "gap": "10px"
    },
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": !_vm.disabledReason
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref3) {
        var on = _ref3.on,
          attrs = _ref3.attrs;
        return [_c('span', _vm._g(_vm._b({
          staticClass: "d-flex",
          staticStyle: {
            "flex": "1 1 0"
          }
        }, 'span', attrs, false), on), [_c('v-btn', {
          staticClass: "button accent text-button wrapping-btn px-3",
          staticStyle: {
            "flex": "1 1 0"
          },
          attrs: {
            "dark": "",
            "large": "",
            "type": "submit",
            "hint": "Get Statistics",
            "loading": _vm.loading,
            "disabled": !!_vm.disabledReason
          }
        }, [_c('v-icon', {
          staticStyle: {
            "margin-right": "5px"
          }
        }, [_vm._v("mdi-chart-bar")]), _vm._v(" Get Statistics ")], 1)], 1)];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.disabledReason))])]), _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": !_vm.disabledReason
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref4) {
        var on = _ref4.on,
          attrs = _ref4.attrs;
        return [_c('span', _vm._g(_vm._b({
          staticClass: "d-flex",
          staticStyle: {
            "flex": "1 1 0"
          }
        }, 'span', attrs, false), on), [_c('v-btn', {
          staticClass: "button greeny text-button wrapping-btn px-3",
          staticStyle: {
            "flex": "1 1 0"
          },
          attrs: {
            "dark": "",
            "large": "",
            "hint": "Download Accounting Report",
            "loading": _vm.loading,
            "disabled": !!_vm.disabledReason
          },
          on: {
            "click": function ($event) {
              return _vm.downloadAccountingReport();
            }
          }
        }, [_c('v-icon', {
          staticStyle: {
            "margin-right": "5px"
          }
        }, [_vm._v(" mdi-microsoft-excel ")]), _vm._v(" Download Report ")], 1)], 1)];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.disabledReason))])])], 1)], 1)], 1)], 1), _vm.showEmptyState ? _c('v-card', {
    staticClass: "mt-6 px-6 py-10 text-center"
  }, [_c('v-avatar', {
    staticClass: "mb-4",
    attrs: {
      "color": "grey lighten-3",
      "size": "56"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey darken-1"
    }
  }, [_vm._v("mdi-magnify-remove-outline")])], 1), _c('div', {
    staticClass: "text-h6 font-weight-bold"
  }, [_vm._v("No orders found in the selected date range.")]), _c('div', {
    staticClass: "text-body-2 grey--text text--darken-1 mt-2 mx-auto",
    staticStyle: {
      "max-width": "480px"
    }
  }, [_vm._v(" Nothing matched these filters, so there are no statistics, charts or orders to show. Try a wider date range or different filters. ")])], 1) : _vm._e(), _vm.showResults ? _c('div', {
    staticClass: "d-flex align-center justify-end flex-wrap mt-6"
  }, [_vm.selectedCurrency === _vm.totalCurrency ? _c('span', {
    staticClass: "text-caption grey--text text--darken-1 mr-3"
  }, [_vm._v(" Total combines all currencies, with amounts converted to SEK. ")]) : _vm._e(), _c('v-btn-toggle', {
    staticClass: "currency-toggle",
    attrs: {
      "mandatory": "",
      "dense": "",
      "active-class": "primary white--text"
    },
    model: {
      value: _vm.selectedCurrency,
      callback: function ($$v) {
        _vm.selectedCurrency = $$v;
      },
      expression: "selectedCurrency"
    }
  }, [_c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "value": _vm.totalCurrency
    }
  }, [_vm._v("Total")]), _vm._l(_vm.currencyOptions, function (currency) {
    return _c('v-btn', {
      key: currency,
      staticClass: "px-4",
      attrs: {
        "value": currency
      }
    }, [_vm._v(" " + _vm._s(currency) + " ")]);
  })], 2)], 1) : _vm._e(), _vm.showResults ? _c('v-row', {
    staticClass: "mt-1"
  }, _vm._l(_vm.summaryTiles, function (tile) {
    return _c('v-col', {
      key: tile.label,
      attrs: {
        "cols": "12",
        "sm": tile.itemCount ? 6 : 4,
        "md": "4",
        "lg": tile.itemCount
      }
    }, [_c('v-card', {
      staticClass: "fill-height px-4 py-3"
    }, [_vm.loading ? _c('v-skeleton-loader', {
      staticClass: "summary-skeleton",
      attrs: {
        "type": "text, heading, text"
      }
    }) : [_c('div', {
      staticClass: "text-subtitle-2 grey--text text--darken-1"
    }, [_vm._v(_vm._s(tile.label))]), _c('div', {
      staticClass: "text-h5 font-weight-bold my-1"
    }, [_vm._v(_vm._s(tile.value))]), _c('div', {
      staticClass: "text-caption grey--text text--darken-1"
    }, [_vm._v(_vm._s(tile.caption))])]], 2)], 1);
  }), 1) : _vm._e(), _vm.showResults ? _c('v-card', {
    staticClass: "my-7 pa-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-tabs', {
    model: {
      value: _vm.chartTab,
      callback: function ($$v) {
        _vm.chartTab = $$v;
      },
      expression: "chartTab"
    }
  }, _vm._l(_vm.chartGroups, function (group) {
    return _c('v-tab', {
      key: group.key,
      attrs: {
        "tab-value": group.key
      }
    }, [_vm._v(" " + _vm._s(group.label) + " Chart ")]);
  }), 1), _c('v-divider', {
    staticClass: "mb-4"
  }), _c('v-tabs-items', {
    model: {
      value: _vm.chartTab,
      callback: function ($$v) {
        _vm.chartTab = $$v;
      },
      expression: "chartTab"
    }
  }, _vm._l(_vm.chartGroups, function (group) {
    return _c('v-tab-item', {
      key: group.key,
      attrs: {
        "value": group.key
      }
    }, [_vm.loading ? _c('v-row', _vm._l(4, function (n) {
      return _c('v-col', {
        key: n,
        attrs: {
          "cols": "12",
          "md": "6"
        }
      }, [_c('v-skeleton-loader', {
        staticClass: "chart-skeleton",
        attrs: {
          "type": "heading, image"
        }
      })], 1);
    }), 1) : !_vm.charts[group.key].length ? _c('div', {
      staticClass: "text-center grey--text py-12"
    }, [_vm._v("No data available")]) : _c('v-row', _vm._l(_vm.charts[group.key], function (chart) {
      return _c('v-col', {
        key: chart.name,
        attrs: {
          "cols": "12",
          "md": "6"
        }
      }, [_c('div', {
        staticClass: "d-flex align-center text-subtitle-2 font-weight-bold"
      }, [_vm._v(" " + _vm._s(chart.name) + " "), _vm.chartNotes[chart.name] ? _c('v-tooltip', {
        attrs: {
          "bottom": "",
          "max-width": "280"
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function (_ref5) {
            var on = _ref5.on,
              attrs = _ref5.attrs;
            return [_c('v-icon', _vm._g(_vm._b({
              staticClass: "ml-1",
              attrs: {
                "small": "",
                "color": "grey"
              }
            }, 'v-icon', attrs, false), on), [_vm._v(" mdi-information-outline ")])];
          }
        }], null, true)
      }, [_c('span', [_vm._v(_vm._s(_vm.chartNotes[chart.name]))])]) : _vm._e()], 1), _c('apexchart', {
        key: _vm.chartsVersion,
        attrs: {
          "type": "line",
          "height": "250",
          "options": chart.options,
          "series": chart.series
        }
      })], 1);
    }), 1)], 1);
  }), 1)], 1)], 1)], 1) : _vm._e(), _c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showResults,
      expression: "showResults"
    }],
    staticClass: "my-7 pa-4"
  }, [_c('div', {
    staticClass: "d-flex align-center justify-space-between pb-3"
  }, [_c('div', {
    staticClass: "text-h6 font-weight-bold"
  }, [_vm._v("Orders")]), _c('div', {
    staticClass: "d-flex"
  }, [_c('export-excel', {
    attrs: {
      "fetch": _vm.fetchAllOrders,
      "fields": _vm.orderExportFields,
      "name": _vm.orderExportName
    }
  }, [_c('v-btn', {
    attrs: {
      "elevation": "2",
      "color": "greeny",
      "dark": "",
      "small": "",
      "loading": _vm.exportingOrders,
      "disabled": !_vm.canExportOrders
    }
  }, [_c('v-icon', [_vm._v(" mdi-microsoft-excel")])], 1)], 1), _c('export-excel', {
    attrs: {
      "fetch": _vm.fetchAllOrders,
      "fields": _vm.orderExportFields,
      "name": _vm.orderExportName,
      "type": "csv"
    }
  }, [_c('v-btn', {
    staticClass: "ml-3",
    attrs: {
      "elevation": "2",
      "dark": "",
      "color": "greeny",
      "small": "",
      "loading": _vm.exportingOrders,
      "disabled": !_vm.canExportOrders
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v(" mdi-table-large")])], 1)], 1)], 1)]), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.orders.items,
      "loading": _vm.loading || _vm.tableLoading,
      "server-items-length": _vm.orders.total,
      "options": _vm.filter,
      "footer-props": {
        'items-per-page-options': [10, 20, 50, 100, 250, 500]
      }
    },
    on: {
      "update:options": _vm.onTableOptionsUpdate
    },
    scopedSlots: _vm._u([{
      key: `item.id`,
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_c('OrderIDField', {
          attrs: {
            "order": item
          }
        })];
      }
    }, {
      key: `item.externalBookingNumbers`,
      fn: function (_ref7) {
        var item = _ref7.item;
        return [_vm._l(_vm.bookingNumbers(item), function (bookingNumber, i) {
          return _c('div', {
            key: i
          }, [_c('h4', {
            staticClass: "grey--text text--darken-4 d-flex text-no-wrap"
          }, [_c('v-tooltip', {
            attrs: {
              "top": "",
              "open-delay": 10,
              "close-delay": 5
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function (_ref8) {
                var on = _ref8.on,
                  attrs = _ref8.attrs;
                return [_c('v-icon', _vm._g(_vm._b({
                  attrs: {
                    "color": "mango-red",
                    "small": ""
                  },
                  on: {
                    "click": function ($event) {
                      return _vm.copyToClipboard(bookingNumber);
                    }
                  }
                }, 'v-icon', attrs, false), on), [_vm._v(" mdi-content-copy ")])];
              }
            }], null, true)
          }, [_c('span', [_vm._v("Copy")])]), _c('span', {
            staticClass: "ml-1 font-weight-bold"
          }, [_vm._v(_vm._s(bookingNumber))])], 1), i + 1 !== _vm.bookingNumbers(item).length ? _c('v-divider') : _vm._e()], 1);
        }), !_vm.bookingNumbers(item).length ? _c('span', {
          staticClass: "grey--text text--darken-2 font-weight-bold"
        }, [_vm._v("—")]) : _vm._e()];
      }
    }, {
      key: `item.created`,
      fn: function (_ref9) {
        var item = _ref9.item;
        return [_c('dateTimeField', {
          attrs: {
            "date": item.created,
            "type": "dateTime"
          }
        })];
      }
    }, {
      key: `item.soldBy`,
      fn: function (_ref10) {
        var item = _ref10.item;
        return [_c('div', {
          staticClass: "d-flex align-center text-no-wrap font-weight-medium"
        }, [item.tenant ? _c('v-tooltip', {
          attrs: {
            "bottom": "",
            "color": "black"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref11) {
              var on = _ref11.on;
              return [_c('v-avatar', _vm._g({
                staticClass: "mr-1",
                attrs: {
                  "width": "20",
                  "height": "20",
                  "tile": "",
                  "min-width": "30"
                }
              }, on), [_c('img', {
                attrs: {
                  "src": _vm.tenantLogoUrl(item.tenant),
                  "alt": item.tenant
                }
              })])];
            }
          }], null, true)
        }, [_c('span', [_vm._v(_vm._s(item.tenant))])]) : _vm._e(), _c('span', [_vm._v(_vm._s(item.soldBy))])], 1)];
      }
    }, {
      key: `item.price`,
      fn: function (_ref12) {
        var _item$price;
        var item = _ref12.item;
        return [_c('span', {
          staticClass: "font-weight-bold text-no-wrap"
        }, [_vm._v(_vm._s(((_item$price = item.price) === null || _item$price === void 0 ? void 0 : _item$price.plainText) || "—"))])];
      }
    }], null, true)
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }